import type { ICurrentUser } from 'context/useCurrentUser/interface'

export const hideZenhubButton = () => {
  window.setTimeout(() => {
    const zenhubButton = document.getElementById('launcher')
    if (zenhubButton !== null) {
      zenhubButton.style.display = 'none'
    }
  }, 3000)
}

/**
 * User id the sidebar needs to build profile-specific links: students use the
 * id embedded in their profile URL (/students/:id/...), everyone else their
 * own id. Pure extraction of the logic Layout always had, shared with the
 * Arc shell.
 */
export const getSidebarUserId = (currentUser?: Pick<ICurrentUser, 'id' | 'profile_used' | 'profile_url'>) => {
  const isStudent = Boolean(currentUser?.id) && currentUser?.profile_used === 'student'
  return isStudent ? currentUser?.profile_url.split('/')[2] : currentUser?.id
}
